// used for impression tracking
export const state = () => ({
    marketplace: [],
    'product-marketplace': [],
    search: [],
    wall: [],
    'ds-marketplace': [],
    'ds-product-marketplace': [],
    'ds-search': [],
    'ds-wall': [],
})

export const getters = {
    getImpressedItems(state) {
        return state
    },
}

export const mutations = {
    updateImpressionList(state, payload) {
        if (!payload?.source) {
            return
        }

        const { source, ...rest } = payload

        if (!state[source]) {
            console.error(`Impression source "${source}" does not exist`)
        }

        state[source].push(rest)
    },
    clearImpressionList(state, payload) {
        state = { ...state, [payload]: [] }
    },
}
